import Tabs from './Tabs';
import TabsPanel from './TabsPanel';

export { Tabs, TabsPanel };


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-tabs/es/index.js
// module id = 538
// module chunks = 0